import { useRef } from 'react';
import Navbar from '../components/Navbar/Navbar';
import MeSection from '../components/MeSection/MeSection';
import About from '../components/About/About';
import Skills from '../components/Skills/Skills';
import Projects from '../components/Projects/Projects';
import Footer from '../components/Footer/Footer';

function HomePage() {
  const projectsRef = useRef<HTMLElement>(null);

  const scrollToProjects = () => {
    projectsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main className="main">
        <MeSection scroll={scrollToProjects} />
        <About />
        <Skills />
        <Projects ref={projectsRef} />
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}

export default HomePage;

